// recording_utils.js
import { createS3UploadParams, uploadToS3V2 } from '../db/aws_s3_utils.js';
import { UpdateLocalStorage } from "../db/localstorage_utils.js";
import { addUploadItem, } from "../db/index_db_utils.js";
import { StartAudio } from './audio_utils.js';
import { triggerBackgroundSync } from './service_worker_utils.js';
import { jsonUploadTrigger } from './json_utils.js';
import config from "./conf.js";

// Orchestrator: starts the recording process.
export const startRecording = async (params) => {
  const {
    setImageButtonContainerStyle,
    audioChunksRef,
    mediaRecorderRef,
    setIsRecording,
    setRecordingExists,
    userData,
    screenId,
    screenTag,
    results,
    recordingStyle,
  } = params;

  // Pre-recording actions
  StartAudio();
  setImageButtonContainerStyle(recordingStyle);

  try {
    // Get user audio stream.
    const stream = await getAudioStream();

    // Initialize the recorder with the stream and audio chunk accumulator.
    const mediaRecorder = initializeMediaRecorder(stream, audioChunksRef);

    // Attach event listeners for recording data and stop event.
    attachRecorderListeners(mediaRecorder, {
      audioChunksRef,
      userData,
      screenTag,
      screenId,
      results,
      setRecordingExists,
    });

    // Start recording and update state.
    mediaRecorder.start();
    setIsRecording(true);
    mediaRecorderRef.current = mediaRecorder;
  } catch (error) {
    console.error("Error accessing microphone:", error);
  }
};

// Helper: Request an audio stream from the user.
function getAudioStream() {
  return navigator.mediaDevices.getUserMedia({ video: false, audio: true });
};

// Helper: Create a MediaRecorder instance and prepare the audio chunk container.
function initializeMediaRecorder(stream, audioChunksRef) {
  const recorder = new MediaRecorder(stream);
  audioChunksRef.current = [];
  recorder.addEventListener("dataavailable", (event) => {
    audioChunksRef.current.push(event.data);
  });
  return recorder;
};

// Helper: Attach 'stop' event listener to process and upload audio data.
function attachRecorderListeners(mediaRecorder, { audioChunksRef, userData, screenTag, screenId, results, setRecordingExists }) {
  mediaRecorder.stopPromise = new Promise((resolve) => {
    mediaRecorder.addEventListener("stop", async () => {
      try {
        await processAndUploadAudio({ audioChunksRef, userData, screenTag, screenId, results, setRecordingExists });
      } finally {
        // Release the mic stream so subsequent recordings aren't silent on WebKit.
        const stream = mediaRecorder.stream;
        if (stream?.getTracks) {
          stream.getTracks().forEach((track) => track.stop());
        }
        resolve(); // Resolve the promise when everything is done
      }
    });
  });
};

// Helper: When recording stops, create a blob and upload it.
async function processAndUploadAudio({ audioChunksRef, userData, screenTag, screenId }) {
  const audioBlob = new Blob(audioChunksRef.current, { type: "audio/wav" });
  const params = await createS3UploadParams(userData, audioBlob, screenTag, "wav", "audio/wav")
  const presignParams = {
    baseUrl: config.COGNET_DB_API_URL,
    patientId: userData.UUID,
    dbName: userData.origin,
    testType: userData.examType,
    attempt: userData.attemptNumber,
    screenId: screenTag,
    extension: "wav",
    contentType: "audio/wav",
    fileBuffer: audioBlob
  };
  UpdateLocalStorage(params.Key, screenId);
  jsonUploadTrigger({userData})
  uploadToS3V2(presignParams).catch(async (err) => {                  // Start upload but don't wait for it
    console.warn('PUT failed, queueing for background-sync:', err);
    await addUploadItem({ params: presignParams });
    await triggerBackgroundSync();
  });
};